import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import { validatePackageProtectionCondition } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type PackageProtectionState = void;

export const PACKAGE_PROTECTION = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<PackageProtectionState>
  >,
): ConditionType<PackageProtectionState, Condition.PackageProtection> => ({
  name: CONDITION_NAMES[Condition.PACKAGE_PROTECTION],
  description() {
    return t("Customer purchased package protection");
  },
  Details(props: ConditionTypeDetailsProps<PackageProtectionState>) {
    return React.createElement(Details, props);
  },
  empty: undefined,
  fromModel() {},
  toModel() {
    return { type: Condition.PACKAGE_PROTECTION };
  },
  valid() {
    return validatePackageProtectionCondition({}).valid;
  },
});
